
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.18 6l-8.25-4.725a1.92 1.92 0 00-1.86 0L2.82 6a1.875 1.875 0 00-.945 1.635V16.5A1.876 1.876 0 002.82 18l8.25 4.665a1.92 1.92 0 001.86 0L21.18 18a1.876 1.876 0 00.945-1.5V7.575A1.875 1.875 0 0021.18 6zM11.07 20.565l-3.195-1.8v-7.95l3.195 1.74v8.01zm.93-9.63l-3.12-1.71 7.215-4.005 3.135 1.77L12 10.935zm0-8.025l2.19 1.23-7.26 4.035L4.77 6.99 12 2.91zM3.75 8.565L6 9.795V17.7l-2.25-1.2V8.565zm9.18 12v-8.01l7.32-3.99V16.5l-7.32 4.065z","fill":"#7B59CE"}})])
          )
        }
      }
    